module.exports = __webpack_public_path__ + "img/sld_scb_4_green.f3409ede.svg";